import React from 'react';
import SettingsLayout from './SettingsLayout';
import ActivitySection from './ActivitySection';

/** /hirewithus/settings/activity — the company activity log. */
const ActivityPage = () => (
  <SettingsLayout activeKey="activity" title="Settings" description="See who did what in your company account.">
    <ActivitySection />
  </SettingsLayout>
);

export default ActivityPage;
